export default __webpack_public_path__ + "static/media/ApplicationForm.6024cd7f.svg";